export class answerCreation {
    answer:string;
    answerType:number;
    baremoRequired:boolean;
    baremoValue?:number;
    timeqty?:number;
    constructor(){}
}
